import { NotebookParam, NotebookParams } from 'src/common/constants/Routes';

export const getNotebookSearchParams = (search: string): NotebookParams => {
  const params = new URLSearchParams(search);
  const databaseId = params.get(NotebookParam.DATABASE) || '';
  const graphs = params.get(NotebookParam.GRAPH) || '';
  const model = params.get(NotebookParam.MODEL);

  return {
    databaseId,
    model,
    namedGraphs: graphs ? graphs.split(',') : [],
  };
};

export const hasNotebookSearchParams = (params: NotebookParams) => {
  return params.databaseId || params.model || params.namedGraphs.length;
};
